import React from "react";

interface MultilineTextInputProps {
  value: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
  textareaRef?: React.RefObject<HTMLTextAreaElement>;
  className?: string;
}

const MultilineTextInput: React.FC<MultilineTextInputProps> = ({
  value,
  onChange,
  placeholder,
  textareaRef,
  className,
}) => {
  const defaultClassName =
    "w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-[var(--fp-ink-3)] focus:border-[var(--fp-ink-3)] resize-vertical";
  const finalClassName = className ? `w-full ${className}` : defaultClassName;

  return (
    <textarea
      ref={textareaRef}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={4}
      className={finalClassName}
    />
  );
};

export default MultilineTextInput;
